import React, { useContext } from 'react';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import {
  FacebookShareButton,
  FacebookIcon,
  TwitterShareButton,
  LinkedinShareButton,
  TwitterIcon,
  LinkedinIcon
} from 'react-share';
import { OfferingsContext } from 'giftcards/core/context/OfferingsContext';

const SocialMediaShareButtons: React.FC = () => {
  const classes = useStyles();
  const { offerings } = useContext(OfferingsContext);
  const title = 'Support our business by purchasing a gift card today.';
  const summary = 'Support our business by purchasing a gift card today.';

  const baseUrl = `${process.env.REACT_APP_PORTAL}/giftcards/${offerings?.[0].uri}`;
  const twitterUrl = `${baseUrl}?utm_source=twitter&utm_medium=social`;
  const facebookUrl = `${baseUrl}?utm_source=facebook&utm_medium=social`;
  const linkedInUrl = `${baseUrl}?utm_source=linkedin&utm_medium=social`;

  return (
    <div className={classes.shareButtons}>
      <TwitterShareButton url={twitterUrl} title='' hashtags={['giftcards', 'supportlocalbusiness', 'covid19']}>
        <TwitterIcon size={40} round />
      </TwitterShareButton>
      <FacebookShareButton url={facebookUrl} title={title} quote={summary}>
        <FacebookIcon size={40} round />
      </FacebookShareButton>
      <LinkedinShareButton url={linkedInUrl} title={title} summary={summary}>
        <LinkedinIcon size={40} round />
      </LinkedinShareButton>
    </div>
  );
};

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    shareButtons: {
      'textAlign': 'center',
      '& button + button': {
        marginLeft: '5px'
      }
    }
  })
);

export default SocialMediaShareButtons;
